import { useAccessKeyIdFromUrl } from "@@/receipts/use-access-key-id-from-url";
import { apiFetchClient } from "@@/shared/fetch-client";
import { createQueryKey } from "@@/shared/state/use-api-resources";
import { useQuery } from "@tanstack/react-query";
import type { AccessKeyId, OrderId } from "@towni/common";

type WillHaveExternalKeysResponse = {
    willHaveExternalKeys: boolean;
};

const fetchWillHaveExternalKeysForOrder =
    (orderId: OrderId | undefined, accessKeyId?: AccessKeyId) => async () => {
        if (!orderId) return { willHaveExternalKeys: false };

        const result = await apiFetchClient.get<{
            item: WillHaveExternalKeysResponse;
        }>({
            route: `/orders/external-access/${encodeURIComponent(orderId)}/check-for-external-keys${
                accessKeyId ? `?ak=${accessKeyId}` : ""
            }`,
        });

        return result.item;
    };

const useWillHaveExternalKeysForOrder = (orderId?: OrderId) => {
    const accessKeyId = useAccessKeyIdFromUrl();

    return useQuery<WillHaveExternalKeysResponse>({
        queryKey: createQueryKey("order-external-access-check", orderId ?? ""),
        queryFn: fetchWillHaveExternalKeysForOrder(orderId, accessKeyId),
        enabled: !!orderId,
    });
};

export { useWillHaveExternalKeysForOrder };
